import React from "react";
import ImagePreview from "./ImagePreview";
const ImagePreviewRail = (props) => {
  const { images, onRemoveImage } = props;
  return /* @__PURE__ */ React.createElement("div", { className: "image-preview-rail" }, images.map((image, index) => {
    return /* @__PURE__ */ React.createElement("div", { className: "image-preview-rail__image", key: image.id }, /* @__PURE__ */ React.createElement(ImagePreview, { image, onRemove: onRemoveImage }));
  }));
};
export default ImagePreviewRail;
